import { authHeader, history, ucpEncrypt, ucpDecrypt } from "../_helpers";
import {
  getLoginErrorMessage,
  isValidLoginResponse,
} from "../_helpers/auth";

import config from "../config";
import { message } from "antd";
export const userService = {
  login,
  logout,
  getAll,
  createUser,
  getAdminUsers,
  getAppUsers,
  updateUser,
  updateAppUser,
  getAppUserTokens,
  getIPLogs,
  saveMapPoliceStation,
  allOfficerUsers,
  mergeOfficerUsers,
  mergeOfficeUserList,
  mergeGunaData,
  findCityWiseUsers,
  UserHeartbeat,
  UserLogout,
  saveMapAdminCity,
  findMapAdminCity,
};

//const baseUrl = 'https://www.criminalmis.in/api';
//const baseUrl = 'http://localhost:8080/api';
const baseUrl = config.apiGateway.baseUrl;
// const baseUrl = "https://www.criminalmis.in/api";

function createUser(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  return fetch(`${baseUrl}/users/create`, requestOptions).then(handleResponse);
}

function login(userid, password, phone, ipAddress, token) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(
      ucpEncrypt({
        userid,
        password,
        phone,
        ipAddress,
        token,
      })
    ),
  };
  return fetch(`${baseUrl}/users/login`, requestOptions)
    .then(handleEncResponse)
    .then((user) => {
      if (!isValidLoginResponse(user)) {
        return Promise.reject(getLoginErrorMessage(user));
      }

      localStorage.setItem("user", JSON.stringify(user));
      sessionStorage.setItem("ssid", JSON.stringify(user.token));
      return user;
    });
}

function logout() {
  try {
    localStorage.removeItem("user");
    sessionStorage.removeItem("ssid");
    localStorage.clear();
    console.log("LocalStorage cleared successfully");
  } catch (error) {
    console.error("Error accessing localStorage:", error);
  }
  history.push("/login");
}

function getAll(cityId, role) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/users/findAllUsers/${cityId}/${role}`,
    requestOptions
  ).then(handleResponse);
}

function getAdminUsers(role) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/users/findAdminUsers/${role}`, requestOptions).then(
    handleResponse
  );
}

function getAppUsers(cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/users/findAppUsers/${cityId}`, requestOptions).then(
    handleResponse
  );
}

function getAppUserTokens(cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/users/appToken/${cityId}`, requestOptions);
}

function updateUser(data, id) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/users/${id}`, requestOptions).then(handleResponse);
}

function updateAppUser(data, id) {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/users/AppUserUpdate/${id}`, requestOptions).then(
    handleResponse
  );
}

function getIPLogs(userid) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/users/iplogs/${userid}`, requestOptions).then(
    handleResponse
  );
}
function saveMapPoliceStation(userid, values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/users/map-police-station/${userid}`,
    requestOptions
  ).then(handleResponse);
}

function handleResponseStatus(response) {
  return response.text().then((text) => {
    const data = text ? JSON.parse(text) : null;

    if (!response.ok) {
      if (response.status === 401) {
        logout();
      }

      const error = data?.message || data?.error || "Something went wrong";

      return Promise.reject(error);
    }

    return data;
  });
}



function handleResponse(response) {
  if (response.status === 401) {
    // auto logout if 401 response returned from api
    logout();
    // location.reload(true);
  }

  return response.text().then((text) => {
    const data = text && JSON.parse(text);

    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
        // location.reload(true);
      }
      if (response.status === 404) {
        //message.error(response.statusText)
      }
      if (response.status === 400) {
        message.error(response.statusText);
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function handleEncResponse(response) {
  return response.text().then((text) => {
    let data = null;

    try {
      data = text && JSON.parse(ucpDecrypt(JSON.parse(text)));
    } catch {
      return Promise.reject("Invalid login response");
    }

    if (!response.ok || !isValidLoginResponse(data)) {
      if (response.status === 401) {
        logout();
        if (response.message == "") window.location.reload(true);
      }

      const error = getLoginErrorMessage(data) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function allOfficerUsers() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/criminal/allOfficerUser`, requestOptions).then(
    handleResponse
  );
}

function mergeOfficerUsers(data, id) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };
  const url = id
    ? `${baseUrl}/criminal/mergeOfficerUsers/${id}`
    : `${baseUrl}/criminal/mergeOfficerUsers`;

  return fetch(url, requestOptions).then(handleResponse);
}
function mergeOfficeUserList() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${baseUrl}/criminal/mergeOfficeUserList`, requestOptions).then(
    handleResponse
  );
}
function mergeGunaData(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/mergeGunaData`, requestOptions).then(
    handleResponse
  );
}
function findCityWiseUsers(cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/users/findCityWiseUsers/${cityId}`,
    requestOptions
  ).then(handleResponse);
}

function UserHeartbeat(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/users/heartbeat`, requestOptions).then(
    handleResponse
  );
}
function UserLogout(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/users/logout`, requestOptions).then(handleResponse);
}

function saveMapAdminCity(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/users/createMapAdminCity`, requestOptions).then(
    handleResponseStatus
  );
}
function findMapAdminCity() {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  return fetch(`${baseUrl}/users/mapAdminCity`, requestOptions).then(
    handleResponse
  );
}
